import React from 'react';
import { colors } from '../constants';

const Dashboard = ({ width, color }) => (
  <svg
    width={width}
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6.75C5.99594 6.75 2.75 9.99594 2.75 14H1.25C1.25 9.16751 5.16751 5.25 10 5.25C14.8325 5.25 18.75 9.16751 18.75 14H17.25C17.25 9.99594 14.0041 6.75 10 6.75Z"
      fill={color}
    />
    <path
      d="M12 13.25C12 14.2165 11.2165 15 10.25 15C9.2835 15 8.5 14.2165 8.5 13.25C8.5 12.2835 9.2835 11.5 10.25 11.5C11.2165 11.5 12 12.2835 12 13.25Z"
      fill="#15372C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.53033 9.46967C7.23744 9.17678 6.76256 9.17678 6.46967 9.46967C6.17678 9.76256 6.17678 10.2374 6.46967 10.5303L8.60127 12.6619C8.53571 12.8457 8.50001 13.0437 8.50001 13.25C8.50001 14.2165 9.28351 15 10.25 15C11.2165 15 12 14.2165 12 13.25C12 12.2835 11.2165 11.5 10.25 11.5C10.0437 11.5 9.84572 11.5357 9.66193 11.6013L7.53033 9.46967Z"
      fill={color}
    />
  </svg>
);

Dashboard.defaultProps = {
  width: 20,
  color: colors.mediumGrey,
};

export default Dashboard;
